/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * Your Project
 * API for all things …
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  Regularization
} from '../../schema'


/**
 * List all regularizations
 */
export const listRegularizations = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Regularization[]>> => {
    return axios.get(
      `/regularizations/`,options
    );
  }


export const getListRegularizationsQueryKey = () => [`/regularizations/`];

    
export type ListRegularizationsQueryResult = NonNullable<Awaited<ReturnType<typeof listRegularizations>>>
export type ListRegularizationsQueryError = AxiosError<unknown>

export const useListRegularizations = <TData = Awaited<ReturnType<typeof listRegularizations>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRegularizations>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListRegularizationsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listRegularizations>>> = ({ signal }) => listRegularizations({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listRegularizations>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Create a new regularization
 */
export const createRegularization = (
    regularization: Regularization, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Regularization>> => {
    return axios.post(
      `/regularizations/`,
      regularization,options
    );
  }



    export type CreateRegularizationMutationResult = NonNullable<Awaited<ReturnType<typeof createRegularization>>>
    export type CreateRegularizationMutationBody = Regularization
    export type CreateRegularizationMutationError = AxiosError<unknown>

    export const useCreateRegularization = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRegularization>>, TError,{data: Regularization}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRegularization>>, {data: Regularization}> = (props) => {
          const {data} = props ?? {};

          return  createRegularization(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof createRegularization>>, TError, {data: Regularization}, TContext>(mutationFn, mutationOptions)
    }
    